export default __webpack_public_path__ + "navigation-examples-custom-banner-v1-1200-a63ee1aeb87a2441e2d4da1836bcdb04.png";